import React from 'react';
import { StickyNav } from '@thd-olt-component-react/sticky-nav';
import { ErrorBoundary } from '@thd-olt-component-react/error-boundary';
import { QueryProvider } from '@thd-nucleus/data-sources';
import PropTypes from 'prop-types';

export const StickyHeader = ({
  channel,
  handleAccordionChange,
  omsId,
  stickyNavRef,
  ratingsRef,
  colorsRef,
  howItWorksRef,
  productOverviewRef,
  specificationsRef,
  questionsRef,
}) => {
  return (
    <div id="sticky-header-container">
      {channel === 'desktop' && (
        <QueryProvider cacheKey="sticky-header">
          <div className="sui-w-full sui-flex sui-flex-wrap">
            <ErrorBoundary name="sticknav">
              <StickyNav
                itemId={omsId}
                ref={stickyNavRef}
                ratingsRef={ratingsRef}
                onRatingsClick={() => handleAccordionChange('#bazaar-voice-reviews', false)}
              >
                <StickyNav.Links>
                  <StickyNav.Link targetRef={howItWorksRef}>
                    <div
                      data-testid="navlink-pso"
                      onClick={() => handleAccordionChange('#how-it-works', false)}
                      role="button"
                      tabIndex={0}
                    >
                      How It Works
                    </div>
                  </StickyNav.Link>
                  <StickyNav.Link targetRef={colorsRef}>
                    <div
                      data-testid="navlink-pso"
                      onClick={() => handleAccordionChange('#colors', false)}
                      role="button"
                      tabIndex={0}
                    >
                      Colors
                    </div>
                  </StickyNav.Link>

                  <StickyNav.Link targetRef={productOverviewRef}>
                    <div
                      data-testid="navlink-pso"
                      onClick={() => handleAccordionChange('#product-overview', false)}
                      role="button"
                      tabIndex={0}
                    >
                      Product Overview
                    </div>
                  </StickyNav.Link>
                  <StickyNav.Link targetRef={specificationsRef}>
                    <div
                      data-testid="navlink-specs"
                      onClick={() => handleAccordionChange('#specifications', false)}
                      role="button"
                      tabIndex={0}
                    >
                      Specifications
                    </div>
                  </StickyNav.Link>
                  <StickyNav.Link targetRef={questionsRef}>
                    <div
                      data-testid="navlink-qa"
                      onClick={() => handleAccordionChange('#bazaar-voice-QA', false)}
                      role="button"
                      tabIndex={0}
                    >
                      Questions & Answers
                    </div>
                  </StickyNav.Link>
                  <StickyNav.Link targetRef={ratingsRef}>
                    <div
                      className="navlink-rr"
                      onClick={() => handleAccordionChange('#bazaar-voice-reviews', false)}
                      role="button"
                      tabIndex={0}
                    >
                      Customer Reviews
                    </div>
                  </StickyNav.Link>
                </StickyNav.Links>
              </StickyNav>
            </ErrorBoundary>
          </div>
        </QueryProvider>
      )}
    </div>
  );
};

StickyHeader.displayName = 'StickyHeader';

StickyHeader.propTypes = {
  channel: PropTypes.string.isRequired,
  handleAccordionChange: PropTypes.func.isRequired,
  omsId: PropTypes.string.isRequired,
  stickyNavRef: PropTypes.func.isRequired,
  ratingsRef: PropTypes.func.isRequired,
  colorsRef: PropTypes.func.isRequired,
  howItWorksRef: PropTypes.func.isRequired,
  productOverviewRef: PropTypes.func.isRequired,
  specificationsRef: PropTypes.func.isRequired,
  questionsRef: PropTypes.func.isRequired,
};

export default StickyHeader;
